var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('static-layout',{attrs:{"title":"Terms and conditions"}},_vm._l((_vm.sections),function(section,key){return _c('div',{key:key,staticClass:"static-content"},[_c('div',{domProps:{"innerHTML":_vm._s(section.content)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }